export const GET_REDIRECT_INFO_REQUEST = 'GET_REDIRECT_INFO_REQUEST';
export const GET_REDIRECT_INFO_SUCCESS = 'GET_REDIRECT_INFO_SUCCESS';
export const GET_REDIRECT_INFO_FAILURE = 'GET_REDIRECT_INFO_FAILURE';
